export default __webpack_public_path__ + "static/media/struct1.80837dee.png";